export const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
export const SYNDICATION_PROGRAM_WAITING_PERIOD_IN_DAYS = 30;
export const APPROVED_IDENTITY_STATUS = 'approved';

export const getSyndicationProgramSignUpCompletedDate = (user) => {
  if (
      user.syndicationProgramSignUpAcknowledgmentsCompletionDate
      && user.proofOfAccreditationDate
  ) {
    const dates = [
      new Date(user.syndicationProgramSignUpAcknowledgmentsCompletionDate).getTime(),
      new Date(user.proofOfAccreditationDate).getTime(),
    ];

    return new Date(Math.max.apply(null, dates)).toISOString();
  }
  return null;
};

export const isWithinSyndicationProgramWaitingPeriod = (syndicationProgramSignUpCompletedDate) => {
  const daysSinceSyndicationProgramCompleted = syndicationProgramSignUpCompletedDate
    ? (new Date().getTime()
      - new Date(syndicationProgramSignUpCompletedDate).getTime())
      / MS_IN_A_DAY
    : 0;
  return daysSinceSyndicationProgramCompleted < SYNDICATION_PROGRAM_WAITING_PERIOD_IN_DAYS;
};

export const isUserEligibleToInvestInSyndication = (userInvestments) => {
  const hasMoiLevelProofOfAccreditation = userInvestments?.accounts?.some(
    (account) => !!account.proofOfAccreditationDate,
  );

  return {
    isEligible: !!(
      hasMoiLevelProofOfAccreditation
        || (userInvestments?.proofOfAccreditationDate
          && userInvestments?.syndicationProgramSignUpAcknowledgmentsCompletionDate)
    ),
    hasMoiLevelProofOfAccreditation,
  };
};
